<template>
  <div class="node-nav h-44 lh-44 font-34" ref="nodeNav">
    <span
      v-for="(node, index) in nodeNav"
      :class="[index === nodeNav.length - 1 ? 'c-171A1D-56' : 'c-006AFE']"
      :key="index"
      @click="handlerClick(node, index)"
    >
      {{ node.deptName || node.name }}
      <i v-if="index < nodeNav.length - 1" class="iconfont c-171A1D-24"
        >&#xe66b;</i
      >
    </span>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'commonNodeNav',
  components: {},
  props: {
    nodeNav: {
      type: Array,
      default: () => []
    },
    nodeType: {
      type: String,
      default: 'deptId'
    }
  },
  data() {
    return {}
  },
  computed: {
    computedCurrentNodeId() {
      return this.nodeNav[this.nodeNav.length - 1][this.nodeType]
    },
    computedNodeLength() {
      return this.nodeNav.length
    }
  },
  watch: {
    computedNodeLength() {
      this.$nextTick(() => {
        const scrollWidth = this.$refs.nodeNav.scrollWidth
        this.$refs.nodeNav.scrollTo(scrollWidth, 0)
      })
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClick(node, index) {
      if (index === this.nodeNav.length - 1) {
        return
      }
      this.$emit('click', node, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.node-nav {
  white-space: nowrap;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
